import { WDD } from '../core/wdd.js';

export function videos() {
    const videos = WDD.el.querySelectorAll('video');
    const hiderInput = WDD.el.querySelector('.bp-hider__input');
    const content = WDD.el.querySelector('.bp-content');

    if (!videos.length) return;

    const observerOptions = {
        threshold: [0, 1]
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const video = entry.target;
                console.log("Video is intersecting, attempting to play:", video);
                void video.play().catch(() => {});
            }
        });
    }, observerOptions);

    let isObserving = false;
    const observeVideos = () => {
        if (isObserving) return;
        isObserving = true;
        videos.forEach(video => observer.observe(video));
    };

    if (!hiderInput || !content || hiderInput.checked) {
        observeVideos();
        return;
    }

    hiderInput.addEventListener('change', () => {
        if (!hiderInput.checked || isObserving) return;

        content.addEventListener('transitionend', event => {
            if (event.target === content && event.propertyName === 'max-height' && hiderInput.checked) {
                observeVideos();
                console.log("Observing videos after transition end");
            }
        }, { once: true });
    });
}

